import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  fetchSubprocessenForEntity,
  initialData,
} from '../services/fetchSubprocessenForEntity'

export { useSubprocessenForEntity, queryKey }

const queryKey = 'entity-subprocessen'
const useSubprocessenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchSubprocessenForEntity(entity),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialData.data,
  }
}
